module.exports = __webpack_public_path__ + "img/textura-2.88db2494.svg";